import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=8f4b9d88&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachDetail.vue?vue&type=style&index=0&id=8f4b9d88&prod&lang=scss&scoped=true"
import style1 from "./CoachDetail.vue?vue&type=style&index=1&id=8f4b9d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4b9d88",
  null
  
)

export default component.exports